// noinspection DuplicatedCode

import React, {useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from 'react-redux';
import {useNavigate} from 'react-router-dom';

import {alertService} from '../../../services/AlertService';

import TableCard from "../../../components/tablecard/TableCard";
import ModalForm from "../../../components/modal/form/ModalForm";

import {getProvinsi, insertProvinsi, provinsiSelector, updateProvinsi} from './provinsiSlice';

import {Colors} from "../../../assets/Colors";
import {maxPageGlobal} from "../../../assets/config";

function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    });
    return ref.current;
}

const ProvinsiPage = ({}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [firstLoading, setFirstLoading] = useState(false);
    const [start, setStart] = useState(0);
    const [count, setCount] = useState(maxPageGlobal);
    const [page, setPage] = useState(1);
    const [maxPage, setMaxPage] = useState(0);
    const [search, setSearch] = useState('');
    const [searchFetch, setSearchFetch] = useState(false);
    const [insertFetch, setInsertFetch] = useState(false);
    const [updateFetch, setUpdateFetch] = useState(false);
    const [showModalAdd, setShowModalAdd] = useState(false);
    const [showModalEdit, setShowModalEdit] = useState(false);
    const [currentData, setCurrentData] = useState({});

    const provinsi = useSelector(
        provinsiSelector
    );

    useEffect(() => {
        dispatch(getProvinsi({
            start: start,
            count: count,
            search: '',
        }));
    }, []);

    useEffect(() => {

        if ((search !== '') && provinsi.isGetSuccess && !provinsi.isGetFetching) {
            let calc = provinsi?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = provinsi.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        } else if ((search === '') && provinsi.isGetSuccess && !provinsi.isGetFetching) {
            let calc = provinsi?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = provinsi.data ? Math.ceil(calc / count) : 1;
            setSearchFetch(false);
            setMaxPage(tempMaxPage);
        }

        if (!provinsi?.isGetFetching && provinsi.isGetSuccess && (maxPage === 0) && (firstLoading === false)) {
            let calc = provinsi?.count - 1;
            if (calc === 0) {
                calc = 1;
            }

            if ((calc % count) === 0) {
                calc = calc + 1;
            }
            let tempMaxPage = provinsi.data ? Math.ceil(calc / count) : 1;
            setMaxPage(tempMaxPage);
            setFirstLoading(true);
            dispatch(getProvinsi({
                start: start,
                count: count,
                search: search,
            }));
        }

        if (
            (insertFetch)
        ) {
            setInsertFetch(false);
            if (provinsi.isGetSuccess) {
                alertService.success(provinsi.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(getProvinsi({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

        if (
            (updateFetch)
        ) {
            setUpdateFetch(false);
            if (provinsi.isUpdateSuccess) {
                alertService.success(provinsi.message, {autoClose: true, keepAfterRouteChange: false});
                dispatch(updateProvinsi({
                    start: start,
                    count: count,
                    search: search,
                }));
            }
        }

    });

    // function handleGetProvinsi(params) {
    //   return dispatch(getProvinsi(params));
    // }

    function handleInsertProvinsi(param) {
        setInsertFetch(true);
        const params = {
            namaProvinsi: param.inputOneValue,
            provinsiID: param.dropdownOneValue,
        };
        dispatch(insertProvinsi(params));
    }

    function handleUpdateProvinsi(param) {
        setUpdateFetch(true);

        const params = {
            namaProvinsi: param.inputOneValue,
            idProvinsi: currentData.ProvinsiID,
            status: param.status,
        };
        dispatch(updateProvinsi(params));
    }

    function handleSearch(searchValue) {
        let params = {
            start: 0,
            count: 5,
            search: searchValue,
        }
        dispatch(getProvinsi(params));

        setStart(0);
        setCount(5);
        setSearch(searchValue);
        setSearchFetch(true);
    }

    function handleUpdatePage(newPage) {
        let newStart = (newPage * count) - count;

        let params = {
            start: newStart,
            count: count,
            search: search,
        }
        dispatch(getProvinsi(params));

        setPage(newPage)
        setStart(newStart)
    }

    function handleUpdateCount(newCount) {
        let calc = (provinsi.count - 1);
        if (calc === 0) {
            calc = 1;
        }

        let params = {
            start: (newCount === "-1") ? 0 : start,
            count: (newCount === "-1") ? provinsi.count : newCount,
            search: search,
        }
        dispatch(getProvinsi(params));

        setPage(1);
        setCount((newCount === "-1") ? provinsi.count : newCount)
        setStart((newCount === "-1") ? 0 : start);
        setMaxPage((newCount === "-1") ? 1 : Math.ceil(calc / newCount))
    }

    function handleCurrentData(values) {
        setCurrentData(values);
    }

    function handleModal(status) {
        setShowModalAdd(status.showModalAdd);
        setShowModalEdit(status.showModalEdit);
    }

    if (!firstLoading) {
        return <div>loading</div>
    } else {
        return (

            <div className="md:ml-64">
                <div style={{background: Colors.primary}} className="pt-14 pb-16 px-3 md:px-8 h-auto">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-4"></div>
                    </div>
                </div>

                <div className="px-3 md:px-8 h-auto -mt-32">
                    <div className="container mx-auto max-w-full">
                        <div className="grid grid-cols-1 px-4">
                            <TableCard
                                backButton={true}
                                backUrl={"master"}
                                handleSearch={handleSearch}
                                searchPlaceholder="Provinsi"
                                updatePage={handleUpdatePage}
                                updateCount={handleUpdateCount}
                                currentData={handleCurrentData}
                                currentPage={page}
                                maxPage={maxPage}
                                tableTitle="Master Provinsi"
                                tableData={provinsi.data}
                                colOneTitle="ID"
                                colOneData="ProvinsiID"
                                colTwoTitle="Nama Provinsi"
                                colTwoData="NamaProvinsi"
                                status="Status"

                                fetching={provinsi.isGetFetching}
                                modal={handleModal}
                                editEnabled={true}

                            />
                        </div>
                    </div>
                </div>
                {showModalAdd &&
                    <ModalForm
                        showModal={showModalAdd}
                        addEnabled={true}
                        modal={handleModal}
                        modalTitle="Tambah Provinsi"
                        dropdownOneTitle="Nama Provinsi"
                        dropdownOneData={provinsi.data}
                        inputOneTitle="Nama Provinsi"
                        inputOnePlaceholder=""
                        submitButtonTitle="Submit"
                        handleSubmit={handleInsertProvinsi}
                    />
                }
                {showModalEdit &&
                    <ModalForm
                        showModal={showModalEdit}
                        editEnabled={true}
                        id={currentData.ProvinsiID}
                        modal={handleModal}
                        modalTitle="Ubah Provinsi"
                        inputOneTitle="Nama Provinsi"
                        inputOneValue={currentData.NamaProvinsi}
                        status={currentData.Status}
                        submitButtonTitle="Submit"
                        handleSubmit={handleUpdateProvinsi}
                    />
                }
            </div>

        )
    }

}


export default ProvinsiPage;